import "./AccountFlyoutBlueSection.scss";

import * as React from "react";
import { BusinessAccount } from "../../../../../datatypes/businessaccounts/BusinessAccount";
import CountryUtil from "../../../../../uidispatcherapi/CountryUtil";

type Props = {
    businessAccount: BusinessAccount | undefined | null;
    activeAccountId: string;
};

type BlueSectionLinks = {
    addMetroCardLink: {
        text: string;
        url: string;
    };
    registerBusinessLink: {
        text: string;
        url: string;
    };
};

export function AccountFlyoutBlueSection(props: Props) {
    if (!props.businessAccount) {
        return null;
    }
    const blueSectionLinks: BlueSectionLinks | null = CountryUtil.getFlyoutConfig().blueSectionLinks || null;

    if (blueSectionLinks) {
        const addMetroCardUrlActiveContext = blueSectionLinks.addMetroCardLink.url.replace(
            "$account-id",
            props.activeAccountId
        );
        const registerBusinessUrlActiveContext = blueSectionLinks.registerBusinessLink.url.replace(
            "$account-id",
            props.activeAccountId
        );
        return (
            <div className="blue-section">
                <div className="add-metro-card-link">
                    <a className="account-label menu-entry" href={addMetroCardUrlActiveContext}>
                        {blueSectionLinks.addMetroCardLink.text}
                    </a>
                </div>
                <div className="register-business-link">
                    <a className="account-label menu-entry" href={registerBusinessUrlActiveContext}>
                        {blueSectionLinks.registerBusinessLink.text}
                    </a>
                </div>
            </div>
        );
    }
    return null;
}
